$(function() {
    $('.btn-toggle-menu').click(function(e) {

        $(this).toggleClass('active');
        
        $('.toggle-menu').slideToggle();
    });
});
